<!-- <mat-card class="menupannel">
  <div class="resUser">
    <button mat-flat-button (click)="showMyDrive()">
      Main Workspace <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
  </div> 
</mat-card> -->

<div class="taskcontainer">


  <div class="myDriveOverlay" (click)="showMyDrive()" [ngClass]="{ open: showmyDrive }"></div>
 

  <div class="right">
    <!-- Section header: title, live counts from the loaded rows, record-level task actions -->
    <div class="tsk-head">
      <div class="tsk-head__text">
        <h2 class="tsk-title">Tasks</h2>
        <div class="tsk-kpis" aria-label="Task summary">
          <span class="tsk-kpi is-open"><strong>{{ statOpenTasks }}</strong> open</span>
          <span class="tsk-kpi is-due" [class.is-alert]="statDueTodayTasks > 0"><strong>{{ statDueTodayTasks }}</strong> due today</span>
          <span class="tsk-kpi is-done"><strong>{{ statCompletedTasks }}</strong> completed</span>
          <span class="tsk-kpi"><strong>{{ statGroupCount }}</strong> {{ statGroupCount === 1 ? 'group' : 'groups' }}</span>
        </div>
      </div>

      <div class="tsk-head__actions">
        <button mat-stroked-button class="tsk-btn" (click)="ImportTaskTemplate(importTasktemplate)">
          <mat-icon>import_export</mat-icon> Import task
        </button>

        <button *ngIf="taskListID > 0" mat-stroked-button class="tsk-btn" (click)="createGroup()">
          <mat-icon>group_add</mat-icon> New group
        </button>

        <button mat-flat-button class="tsk-btn tsk-btn--primary" (click)="createNewTask()">
          <mat-icon>add</mat-icon> One-off task
        </button>
      </div>
    </div>

    <mat-card class="tsk-panel">

      <!-- One toolbar row: current view (switchable), search, filters -->
      <div class="filter tsk-toolbar">

        <div class="pageHeading">
          <button type="button" [matMenuTriggerFor]="notification" class="user-button tsk-viewpick"
            matTooltip="Switch between this list and all, mine or my role's tasks" matTooltipClass="tooltip">
            <span class="tsk-viewpick__label">Showing</span>
            <span class="tsk-viewpick__name">{{ myTaskText }}</span>
            <mat-icon>expand_more</mat-icon>
          </button>
          <mat-menu class="customPanel" #notification="matMenu">
            <mat-card class="filterOptionList">
              <div class="fillist">
                <div class="filterlist">

                  <div class="lList">
                    <span class="name" (click)="onFilterByMyTask(1,'All Task')">All Task</span>

                    <button mat-icon-button>
                      <mat-icon class="star">bookmark</mat-icon>
                    </button>

                    <button mat-icon-button class="remove">
                      <mat-icon class="">highlight_off</mat-icon>
                    </button>
                  </div>
                  <div class="lList">
                    <span class="name" (click)="onFilterByMyTask(2,'Created by me')">Created by me</span>

                    <button mat-icon-button>
                      <mat-icon class="star">bookmark</mat-icon>
                    </button>

                    <button mat-icon-button class="remove">
                      <mat-icon class="">highlight_off</mat-icon>
                    </button>
                  </div>
                  <div class="lList">
                    <span (click)="onFilterByMyTask(3,'Assigned to me')" class="name">Assigned to me</span>

                    <button mat-icon-button>
                      <mat-icon class="star">bookmark</mat-icon>
                    </button>

                    <button mat-icon-button class="remove">
                      <mat-icon class="">highlight_off</mat-icon>
                    </button>
                  </div>
                  <div class="lList">
                    <span class="name" (click)="onFilterByMyTask(4,'My Role')">My Role</span>

                    <button mat-icon-button>
                      <mat-icon class="star">bookmark</mat-icon>
                    </button>

                    <button mat-icon-button class="remove">
                      <mat-icon class="">highlight_off</mat-icon>
                    </button>
                  </div>

                </div>
              </div>
            </mat-card>
          </mat-menu>
        </div>

        <div class="tsk-search">
          <mat-icon class="tsk-search__icon">search</mat-icon>
          <input type="text" placeholder="Search tasks, lists, or owners..." (input)="getSearchResults()"
            [(ngModel)]="value" />
          <button mat-icon-button class="tsk-search__clear" *ngIf="value" aria-label="Clear"
            (click)="clearSerachText()">
            <mat-icon>close</mat-icon>
          </button>
        </div>

        <div class="tsk-toolbar__filters">

          <div class="sort">
            <button mat-stroked-button class="tsk-filter" [ngClass]="{'active':preorityArray.length>0}"
              [matMenuTriggerFor]="priority">{{preoritytext}}<mat-icon>arrow_drop_down</mat-icon></button>
            <mat-icon class="cancelFilter" (click)="clearPreoority()" *ngIf="preorityArray.length>0">close</mat-icon>
            <mat-menu #priority="matMenu">
              <button mat-menu-item (click)="onFilterByPreority(1,'Lowest')">Lowest</button>
              <button mat-menu-item (click)="onFilterByPreority(2,'Low')">Low</button>
              <button mat-menu-item (click)="onFilterByPreority(3,'Medium')">Medium</button>
              <button mat-menu-item (click)="onFilterByPreority(4,'High')">High</button>
              <button mat-menu-item (click)="onFilterByPreority(5,'Highest')">Highest</button>
            </mat-menu>

            <button mat-stroked-button class="tsk-filter" [ngClass]="{'active':dueDatetext!=='Due Date'}"
              [matMenuTriggerFor]="dueDate">{{dueDatetext}}<mat-icon>arrow_drop_down</mat-icon></button>
            <mat-icon class="cancelFilter" *ngIf="dueDatetext!=='Due Date'" (click)="clearDuedate()">close</mat-icon>
            <mat-menu #dueDate="matMenu">
              <button mat-menu-item (click)="GettaskByFilter('Today')">Today</button>
              <button mat-menu-item (click)="GettaskByFilter('Tomorrow')">Tomorrow</button>
              <button mat-menu-item (click)="GettaskByFilter('This Week')">This Week</button>
              <button mat-menu-item (click)="GettaskByFilter('Next Week')">Next Week</button>
              <button mat-menu-item (click)="GettaskByFilter('Overdue')">Overdue</button>
            </mat-menu>
          </div>

          <span class="tsk-toolbar__divider" *ngIf="taskListID > 0"></span>

          <button *ngIf="taskListID > 0" class="viewBtn tsk-icon-btn" mat-icon-button
            (click)="customizeColumn(customize)" matTooltipClass="tooltip" matTooltip="Customize Column">
            <mat-icon>view_column</mat-icon>
          </button>



        </div>

      </div>

      <!-- Bulk bar: only while rows are selected -->
      <div class="tsk-bulkbar" *ngIf="showMoveToOption">
        <span class="tsk-bulkbar__count">{{ selection.selected.length }} selected</span>

        <button mat-stroked-button class="tsk-btn" (click)="moveTo(MoveTo)">
          <mat-icon>low_priority</mat-icon> Move to
        </button>

        <button mat-stroked-button class="tsk-btn" (click)="SaveAsTemplateMultiple(saveAsTemplateDialog)">
          <mat-icon>save</mat-icon> Save as template
        </button>

        <button mat-stroked-button class="tsk-btn tsk-btn--danger" (click)="deleteMultipleTask()">
          <mat-icon>delete</mat-icon> Delete
        </button>
      </div>

   <div class="tableHolder">
    <mat-card class="task_holder--group--items--row cellHeader" [class.is-inset]="taskListID > 0">

      <div class="task_header_holder cvcxxcv">
        <ng-container>
          <div class="task-cell cellName">
            <div class="Headeroutside">
              <mat-checkbox class="taskcheck" color="primary" [disabled]="ShowNoRecordFound"
                (change)="$event ? masterToggle() : null"
                [checked]="selection.hasValue() && isAllSelected()">
               </mat-checkbox>
            </div>
            Task
          </div>
          <div class="task-cell cellAssigne tsk-owner">Owner</div>
          <div class="task-cell cellDueDate tsk-due">Due</div>
          <div class="task-cell cellPriority">Priority</div>
          <div class="task-cell cellStatus">Status</div>
          <div class="task-cell cellAction"></div>
        </ng-container>  
        
        <ng-container *ngIf="taskListID > 0 && FieldColumn.length>0">           
            <div class="task-cell cellPriority" *ngFor="let clm of FieldColumn">
              <span>{{clm.fieldName}}</span>
            </div>           
       </ng-container>

      </div>

    </mat-card>

    <div class="task_holder" *ngFor="let column of columns" style="width:100%">
      <div class="task_holder--group" cdkDropList [cdkDropListData]="column.groups"
        (cdkDropListDropped)="dropGroup($event)">
        <mat-card class="task_holder--group--items tsk-group" *ngFor="let group of column.groups; let gi = index"
          cdkDropListGroup cdkDrag [cdkDragDisabled]="group.dragDisabled" [cdkDragData]="group"
          [class.is-collapsed]="collapsedGroups[group.id]" [class.has-head]="taskListID > 0"
          [ngStyle]="taskListID > 0 ? {'border-left-color': groupAccent(gi)} : null">

          <!-- Group header (list view): name, task count, progress by status, collapse -->
          <div class="tsk-group__head" *ngIf="taskListID > 0">
            <span class="tsk-group__icon" [ngStyle]="{'color': groupAccent(gi)}">
              <mat-icon>{{ group.dragDisabled ? 'view_list' : 'folder_open' }}</mat-icon>
            </span>

            <div class="tsk-group__text">
              <input *ngIf="group.id > 0 && !group.dragDisabled" class="tsk-group__name" type="text" maxlength="50"
                (change)="onChangeGroupName($event,group)" value="{{group.title}}" aria-label="Group name"
                matTooltip="Click to rename" matTooltipClass="tooltip">
              <span *ngIf="!(group.id > 0 && !group.dragDisabled)" class="tsk-group__name">
                {{ group.title == 'Default Group' ? 'General' : group.title }}
              </span>
              <span class="tsk-group__meta">
                {{ group.items?.length || 0 }} {{ (group.items?.length || 0) === 1 ? 'task' : 'tasks' }}
                <ng-container *ngIf="group.isTriggered"> · Triggered</ng-container>
              </span>
            </div>

            <div class="tsk-group__progress" [class.is-complete]="group.items?.length && groupDone(group) === group.items.length">
              <span>{{ groupDone(group) }}/{{ group.items?.length || 0 }} complete</span>
              <div class="tsk-bar">
                <i [style.width.%]="groupPercent(group)" [ngStyle]="{'background': groupAccent(gi)}"></i>
              </div>
            </div>

            <button mat-icon-button class="tsk-group__btn" *ngIf="group.id > 0 && !group.dragDisabled"
              (click)="removeGroup(group)" matTooltip="Delete group" matTooltipClass="tooltip" aria-label="Delete group">
              <mat-icon>delete_outline</mat-icon>
            </button>
            <button mat-icon-button class="tsk-group__btn" (click)="toggleGroup(group)"
              [attr.aria-expanded]="!collapsedGroups[group.id]"
              [attr.aria-label]="collapsedGroups[group.id] ? 'Expand group' : 'Collapse group'">
              <mat-icon>{{ collapsedGroups[group.id] ? 'expand_more' : 'expand_less' }}</mat-icon>
            </button>
          </div>

          <form [formGroup]="statusGroup" *ngIf="!collapsedGroups[group.id]">
            <mat-card style="width:100%" class="example-list" cdkDropList id="{{group.id}}"
              [cdkDropListData]="group.items" (cdkDropListDropped)="dropItem($event)"
              [cdkDropListConnectedTo]="getConnectedList()">

              <div class="task_holder--group--items--row" *ngFor="let item of group.items; let i = index" cdkDrag
                [cdkDragData]="item" [cdkDragDisabled]="taskListID==0">

                <!-- Task: title plus a meta line built from the task's own data -->
                <div class="task-cell cellName">
                  <div class="outside">
                    <mat-checkbox class="taskcheck" color="primary" (change)="isAllSelectedRow($event,item)"
                      (change)="$event ? selection.toggle(item) : null" [checked]="selection.isSelected(item)">
                    </mat-checkbox>
                  </div>

                  <button mat-icon-button class="tsk-done-btn" (click)="markComplete(item)"
                    [ngClass]="{ markComplete: item.status==completedTaskStatusID }"
                    [matTooltip]="item.status==completedTaskStatusID ? 'Completed' : 'Mark complete'" matTooltipClass="tooltip">
                    <mat-icon>{{ item.status==completedTaskStatusID ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
                  </button>

                  <div class="tname tsk-task" (click)="getTaskDetail(item)">
                    <div class="tsk-task__title">
                      <span class="taskColor"
                        [ngStyle]="{'background-color': (taskListID>0 || taskListIDSharedWithMe>0) ? item.colourCode : item.color}"></span>
                      <span class="taskTitle" [class.is-done]="item.status==completedTaskStatusID"
                        [matTooltip]="item.description" matTooltipClass="tooltip" [matTooltipDisabled]="!item.description">
                        {{ item.taskTitle }}
                      </span>

                      <!-- type / external / required / dependency tags sit at the right end of the title line -->
                      <span class="tsk-task__tags">
                        <span class="tsk-tag" *ngIf="taskAction(item) as act">
                          <mat-icon>{{ act.icon }}</mat-icon>{{ act.label }}
                        </span>
                        <span class="tsk-tag tsk-tag--ext" *ngIf="!item.isInternal"
                          matTooltip="Completed by the resident or family through a link" matTooltipClass="tooltip">
                          <mat-icon>arrow_outward</mat-icon>External
                        </span>
                        <span class="tsk-tag tsk-tag--req" *ngIf="item.isRequired">Required</span>
                      </span>
                    </div>

                    <!-- description (and checklist progress) below the title -->
                    <div class="tsk-task__meta" *ngIf="item.description || item.subTaskCount > 0">
                      <span class="tsk-meta-text tsk-meta-text--desc" *ngIf="item.description">{{ item.description }}</span>
                      <span class="tsk-meta-text" *ngIf="item.subTaskCount > 0">
                        {{ item.completedSubTaskCount || 0 }}/{{ item.subTaskCount }} checklist items
                      </span>
                    </div>
                  </div>
                </div>

                <!-- Owner -->
                <div class="task-cell cellAssigne tsk-owner" (click)="getTaskDetail(item)">
                  <ng-container *ngIf="getAssigne(item.taskAssignedEntity) as owners">
                    <ng-container *ngIf="owners.length > 0; else noOwner">
                      <ul class="assignList">
                        <ng-container *ngFor="let o of owners; let i = index; trackBy: trackByFn">
                          <li *ngIf="i < 3">
                            <ng-container *ngIf="o.image; else ownerInitials">
                              <div class="userImage" matTooltipClass="tooltip" matTooltip="{{o.name}}">
                                <img src="{{o.image}}" alt="{{o.name}}">
                              </div>
                            </ng-container>
                            <ng-template #ownerInitials>
                              <span class="shortName" matTooltipClass="tooltip" matTooltip="{{o.name}}">{{ getShortName(o.name) }}</span>
                            </ng-template>
                          </li>
                        </ng-container>
                      </ul>
                      <span class="tsk-owner__name">
                        {{ owners[0].name }}<ng-container *ngIf="owners.length > 1"> +{{ owners.length - 1 }}</ng-container>
                      </span>
                    </ng-container>
                  </ng-container>
                  <ng-template #noOwner><span class="tsk-muted">Unassigned</span></ng-template>
                </div>

                <!-- Due -->
                <div class="task-cell cellDueDate tsk-due" (click)="getTaskDetail(item)">
                  <ng-container *ngIf="dueInfo(item) as due; else noDue">
                    <span class="tsk-due__label" [ngClass]="'is-' + due.state">
                      <mat-icon>{{ due.state === 'overdue' ? 'error_outline' : 'event' }}</mat-icon>{{ due.label }}
                    </span>
                  </ng-container>
                  <ng-template #noDue><span class="tsk-muted">No due date</span></ng-template>
                </div>

                <div class="task-cell cellPriority">

                  <ng-select [readonly]="SingleTaskArchived==true" class="priority_dropdown" formControlName="priority{{item.taskId}}" [searchable]="false"
                    [clearAllText]="false" (change)="onTaskListPriorityChange($event,item)">

                    <ng-option *ngFor="let priority of taskPriorityNameColorCode" [value]="priority.val">
                      <span class="statusOptions"
                        [ngStyle]="{'color': priority.color}"><mat-icon>{{priority.icon}}</mat-icon>{{ priority.name
                        }}</span>
                    </ng-option>

                  </ng-select>

                </div>

                <div class="task-cell cellStatus">

                  <ng-select [readonly]="SingleTaskArchived==true" formControlName="status{{item.taskId}}" [searchable]="false" [clearAllText]="false"
                    (change)="onTaskListStatusChange($event,item)" class="status_dropdown">

                    <ng-option *ngFor="let stat of taskStatusList" [value]="stat.taskStatusID">
                      <span class="statusOptions" [style.background]="getBackground(stat.taskStatusID)">{{
                        stat.taskStatusName }}</span>
                    </ng-option>

                  </ng-select>

                </div>

                 <!-- <div *ngIf="SingleTaskArchived==false"   class="task-cell cellAction"> -->
                <div *ngIf="SingleTaskArchived==false" class="task-cell cellAction">

                  <span mat-icon-button [matMenuTriggerFor]="taskSubActions"><mat-icon>more_vert</mat-icon>
                  </span>
                  <mat-menu class="taskMatMenu" #taskSubActions="matMenu" xPosition="before">
                   
                    <button mat-menu-item (click)="MakeTaskRequired(item, !item.isRequired)">
                      <mat-icon>{{ item.isRequired ? 'remove_done' : 'priority_high' }}</mat-icon>{{ item.isRequired ? 'Mark as optional' : 'Mark as required' }}
                    </button>
                    <button mat-menu-item (click)="openTaskUrl(item)">
                      <mat-icon>content_copy</mat-icon>Copy URL
                    </button>
                    <button mat-menu-item (click)="SaveAsTemplateForSingleTask(saveAsTemplateTaskDialog,item)">                      
                      <mat-icon>save</mat-icon>
                      Save as Template
                    </button>
                    <button mat-menu-item (click)="sendManualTaskReminder(sendReminder,item)">
                      <mat-icon> email</mat-icon>
                      Send Email Notification</button>
                    <button mat-menu-item (click)="ArchiveTask(item)">
                      <mat-icon>archive</mat-icon>
                      Archive
                    </button>
                    <button mat-menu-item (click)="deleteTask(item)">
                      <mat-icon>delete</mat-icon>
                      Delete
                    </button>
                  </mat-menu>
                </div>
                       
                
                 <ng-container *ngIf="taskListID > 0 && FieldColumn.length > 0">
                    <div *ngFor="let rowdata of FieldColumn"  
                     [ngClass]="{'task-cell': true, 'cellPriority': true,'email': getFieldType(rowdata, item)}" >

                    <ng-container *ngIf="getFieldType(rowdata, item); else defaultView">
                      <span matTooltipClass="tooltip"
                        matTooltip="{{ getFieldColumnValues(rowdata, item) }}">
                        {{ getFieldColumnValues(rowdata, item) }}
                      </span>
                    </ng-container>
                
                    <ng-template #defaultView>
                      {{ getFieldColumnValues(rowdata, item) }}
                    </ng-template>
                    </div>
                  </ng-container>
                  
                <div *ngIf="ShowNoRecordFound" class="noRecordFound">No record found</div>
            
              </div>
            </mat-card>
          </form>
         
         

        </mat-card>
        
        
      </div>
      
    </div>
  </div>

      <div class="tsk-empty" *ngIf="ShowNoRecordFound">
        <mat-icon>inbox</mat-icon>
        <p>No tasks match this view yet.</p>
      </div>

    </mat-card>
    <!-- <form [formGroup]="statusGroup">
    <mat-card class="allTaskHolder">
      <div class="zui-wrapper">       
        <div class="zui-scroller"> 
        
          <mat-table *ngIf="!ShowNoRecordFound" class="zui-table scrollfix" [dataSource]="dataSource" cdkDropList [cdkDropListData]="dataSource.data"
          (cdkDropListDropped)="dropTable($event)"  [cdkDropListDisabled]="taskListID==0">
       
            <ng-container matColumnDef="taskTitle">
              <mat-header-cell *matHeaderCellDef>
                <mat-checkbox class="taskcheck" color="primary" [disabled]="ShowNoRecordFound"
                (change)="$event ? masterToggle() : null"
                [checked]="selection.hasValue() && isAllSelected()">
               </mat-checkbox>                
                <span class="ml-10" >Title</span>
              </mat-header-cell>
              <mat-cell  class="taskName"  [ngClass]="{'showCheckBox': showAllCheckBoxes || selection.isSelected(task) }"  *matCellDef="let task">   
                <div class="outside">
                  <mat-icon class="moveIcon" *ngIf="taskListID>0" cdkDragHandle>drag_handle</mat-icon>

               <mat-checkbox  class="taskcheck"color="primary" (change)="isAllSelectedRow($event,task)"
               (change)="$event ? selection.toggle(task) : null"
               [checked]="selection.isSelected(task)">
               </mat-checkbox>
                </div>

                <button mat-icon-button (click)="markComplete(task)" class="notComplete" 
                 [ngClass]="{ markComplete: task.status==completedTaskStatusID }">
                  <mat-icon>check_circle_outline</mat-icon>
                </button>

                

                <div class="tname" >
                
                  <span *ngIf="taskListID==0" (click)="getTaskDetail(task)" class="taskColor" [ngStyle]="{'background-color': task.color}"></span>
                  <span *ngIf="taskListID>0" (click)="getTaskDetail(task)" class="taskColor" [ngStyle]="{'background-color': task.colourCode}"></span>

                  <span *ngIf="taskListID==0" (click)="getTaskDetail(task)" class="taskTitle">{{ task.taskTitle }}</span>
                  <span *ngIf="taskListID>0" (click)="getTaskDetail(task)" class="taskTitle">{{ task.taskTitle }}</span>
                                                               
                  <div class="taskstatusCount">                    
                    <span class="complete" *ngIf="task.completedSubTaskCount > 0" >{{task.completedSubTaskCount}}</span>
                    <span class="working" *ngIf="task.inprogressTaskCount > 0" >{{task.inprogressTaskCount}}</span>
                                   
                  </div>
                </div>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="dueDate">
              <mat-header-cell *matHeaderCellDef  class="w100">Due Date</mat-header-cell>
              <mat-cell (click)="getTaskDetail(task)" class="w100" *matCellDef="let task">
                <p *ngIf="task.dueDate == null">
                  <mat-icon class="greyIcon">
                    event
                  </mat-icon>
                </p>
                <p *ngIf="task.dueDate != null">
                  {{ task.dueDate | date: "MM/dd/yyyy" }}                 
                </p>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="status">
              <mat-header-cell *matHeaderCellDef  class="w100">Status</mat-header-cell>
              <mat-cell class="w100" *matCellDef="let task">             
                <div class="taskStatusPriority">
                  <ng-select [readonly]="SingleTaskArchived==true" formControlName="status{{task.taskId}}" [searchable]="false" [clearAllText]="false"
                    class="status_dropdown ngselect" (change)="onTaskListStatusChange($event,task)">
                    <ng-option *ngFor="let stat of taskStatusList" [value]="stat.taskStatusID">
                      <span class="statusOptions" [style.background]="getBackground(stat.taskStatusID)">
                        {{stat.taskStatusName }}
                      </span>
                    </ng-option>
                </ng-select>
                </div>
              </mat-cell>
            </ng-container>
          
            <ng-container matColumnDef="priority">
              <mat-header-cell *matHeaderCellDef  class="w100">Priority</mat-header-cell>
              <mat-cell class="w100" *matCellDef="let task">
                <div class="taskStatusPriority">
                  <ng-select [readonly]="SingleTaskArchived==true" class="priority_dropdown ngselect" formControlName="priority{{task.taskId}}" [searchable]="false"
                  [clearAllText]="false" (change)="onTaskListPriorityChange($event,task)" >
  
                  <ng-option *ngFor="let priority of taskPriorityNameColorCode" [value]="priority.val">
                    <span class="statusOptions"
                      [ngStyle]="{'color': priority.color}"><mat-icon>{{priority.icon}}</mat-icon>{{ priority.name
                      }}</span>
                  </ng-option>
                  </ng-select>
                </div>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Action">
              <mat-header-cell *matHeaderCellDef  class="w100" >Action</mat-header-cell>
              <mat-cell  class="w100" *matCellDef="let task">
                   
                <div class="forHover">
                      
                  <span mat-icon-button [matMenuTriggerFor]="taskSubActions"><mat-icon>more_vert</mat-icon>
                  </span>
                  
                  </div>                  

                 
                  <mat-menu  class="taskMatMenu" #taskSubActions="matMenu" xPosition="before">                   
                    <button *ngIf="SingleTaskArchived==false" mat-menu-item (click)="openTaskUrl(task)">
                      <mat-icon>content_copy</mat-icon>Copy URL</button>

                    <button *ngIf="SingleTaskArchived==false" mat-menu-item (click)="SaveAsTemplateForSingleTask(saveAsTemplateTaskDialog,task)">                      
                      <mat-icon>save</mat-icon>
                      Save as Template
                    </button>

                    <button *ngIf="SingleTaskArchived==false" mat-menu-item (click)="sendManualTaskReminder(sendReminder,task)">
                      <mat-icon> email</mat-icon>Send Email Notification</button>

                      <button *ngIf="SingleTaskArchived==false" mat-menu-item (click)="ArchiveTask(task)">
                       <mat-icon>archive</mat-icon> Archive</button>

                    <button *ngIf="SingleTaskArchived==false" mat-menu-item (click)="deleteTask(task)">
                      <mat-icon>delete</mat-icon> Delete</button>
                   

                    <button *ngIf="SingleTaskArchived==true" mat-menu-item (click)="UnArchiveTask(task)">
                      <mat-icon>unarchive</mat-icon>UnArchive</button>

                  </mat-menu>       
                  
                  
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns" cdkDrag [cdkDragData]="row"></mat-row>            
          </mat-table>

          </div>
          
          <div *ngIf="ShowNoRecordFound" class="noRecordFound">No record found</div>
         
      </div>
    </mat-card>
    </form> -->

  
    <ng-container *ngIf="showAssignedTask">
      <mat-card class="createTask" cdkDrag cdkDragBoundary=".right">
        <app-task-assign [taskId]="taskId" [fromList]="true"
         (closeAssignedTask)="closeTask($event)">
        </app-task-assign>
      </mat-card>
    </ng-container>
    

    <ng-container *ngIf="showAttachTask">
      <div class="createTask" cdkDrag cdkDragBoundary=".right">
        <app-task-attach-ccc [taskId]="taskId" [fromList]="true"
          (closeAssignedTask)="closeAttach($event)">
        </app-task-attach-ccc>
      </div>
    </ng-container> 

    <ng-container *ngIf="showCreateTask">
      <mat-card class="createTask ssss" cdkDrag cdkDragBoundary=".right">
        <app-addtask
          (getCloseCreateTask)="getCloseCreateTask()"
          (getSaveTask)="getSaveTask()"
          [taskId]="taskId"
          [taskListID]="taskListID"
          [moduleName]="moduleNames"
          [name]="name"
          [email]="email"
          [imageUrl]="imageUrl"
          [transactionID]="transactionIDForTask"
          [typeId]="typeIdForTask" [typeIdDrp]="TypeIdDrp">
        </app-addtask>
      </mat-card>
    </ng-container>

  </div>
</div>


<app-task-details
  *ngIf="showTaskDetail"
  [ngClass]="{ open: showTaskDetail }"
  (closeTaskDetail)="closeTaskDetail($event)"
  (closeSaveTaskDetail)="closeSaveTaskDetail($event)"
  (showPI)="showPIntelligence($event)"
  [taskId]="taskId"
  [mainModulename]="mainModuleName" [SingleTaskArchived]="SingleTaskArchived"
  [showAddGroupButtonCore]="showAddGroupButtonCore">
</app-task-details>


<!-- <app-task3c-tasklists  *ngIf="showTaskListsLeft"
 [ngClass]="{'open': showTaskListsLeft}"
 (closeTaskList)="closeTaskList($event)"
 [modulename]="Module"
 [mainModulename]="mainModuleName"
 [transactionID]="transactionIDForTask"
 [typeId]="typeIdForTask"
 (getMyTask)="getMyTask()"
 (OpenTaskLists)=OpenTaskLists($event)>
</app-task3c-tasklists> -->


<app-add-pi
  [ngClass]="{ open: showProcess }"
  (closeLinkPI)="closePIntelligence($event)">
</app-add-pi>



<ng-template #MoveTo>
  <div class="tsk-move">
    <div class="tsk-move__head">
      <span class="tsk-move__icon"><mat-icon>drive_file_move</mat-icon></span>
      <div class="tsk-move__title">
        <h2>Move {{ selectedRecordMoveToArray.length }} {{ selectedRecordMoveToArray.length === 1 ? 'task' : 'tasks' }}</h2>
        <p>Open a folder and pick the task list to move {{ selectedRecordMoveToArray.length === 1 ? 'it' : 'them' }} into.</p>
      </div>
      <button mat-icon-button class="tsk-move__close" (click)="closeMoveto()" aria-label="Close">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="tsk-move__search">
      <mat-icon>search</mat-icon>
      <input type="text" [(ngModel)]="moveSearch" placeholder="Search folders" aria-label="Search folders" />
      <button type="button" *ngIf="moveSearch" (click)="moveSearch = ''" aria-label="Clear search">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="tsk-move__body">
      <div class="tsk-move__folder" *ngFor="let tasklist of filteredMoveFolders; let i = index"
        [class.is-open]="i === expandedIndexmoveTo">

        <button type="button" class="tsk-move__folder-row" (click)="toggleMoveFolder(tasklist, i)"
          [attr.aria-expanded]="i === expandedIndexmoveTo">
          <mat-icon class="tsk-move__chevron">chevron_right</mat-icon>
          <mat-icon class="tsk-move__folder-icon">{{ i === expandedIndexmoveTo ? 'folder_open' : 'folder' }}</mat-icon>
          <span class="tsk-move__name">{{ tasklist.taskListFolderName }}</span>
        </button>

        <div class="tsk-move__lists" *ngIf="i === expandedIndexmoveTo">
          <p class="tsk-move__hint" *ngIf="loadingMoveToLists">Loading lists…</p>
          <p class="tsk-move__hint" *ngIf="!loadingMoveToLists && taskListsForMoveTo.length === 0">No task lists in this folder.</p>

          <button type="button" class="tsk-move__list" *ngFor="let list of taskListsForMoveTo"
            [class.is-selected]="taskListIDMoveTo === list.taskListID"
            [class.is-current]="taskListID == list.taskListID"
            [disabled]="taskListID == list.taskListID"
            (click)="SelectTaskList(list)">
            <mat-icon class="tsk-move__radio">
              {{ taskListIDMoveTo === list.taskListID ? 'radio_button_checked' : 'radio_button_unchecked' }}
            </mat-icon>
            <span class="tsk-move__name">{{ list.taskListName }}</span>
            <span class="tsk-move__tag" *ngIf="taskListID == list.taskListID">Current list</span>
          </button>
        </div>
      </div>

      <p class="tsk-move__empty" *ngIf="filteredMoveFolders.length === 0">
        {{ moveSearch ? 'No folders match "' + moveSearch + '".' : 'No folders yet.' }}
      </p>
    </div>

    <div class="tsk-move__foot">
      <span class="tsk-move__target" *ngIf="moveToTargetName; else noTarget">
        Moving to <strong>{{ moveToTargetName }}</strong>
      </span>
      <ng-template #noTarget><span class="tsk-move__target is-empty">No list selected</span></ng-template>

      <button mat-button class="tsk-btn" (click)="closeMoveto()">Cancel</button>
      <button mat-flat-button class="tsk-btn tsk-btn--primary" [disabled]="!ButtonForMoveTo || spinner"
        (click)="MoveToTaskList()">
        <mat-spinner *ngIf="spinner" diameter="16"></mat-spinner>
        Move {{ selectedRecordMoveToArray.length === 1 ? 'task' : 'tasks' }}
      </button>
    </div>
  </div>
</ng-template>


<ng-template #saveAsTemplateDialog>
  <form [formGroup]="addTemplateForm"> 
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>create_new_folder</mat-icon></span>
    Save As Template
    <button mat-icon-button (click)="closeSaveAsTemplate()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content>  

    <mat-form-field appearance="fill">
      <mat-label>Select Category</mat-label>
      <mat-select formControlName="folderID">
        <mat-option *ngFor="let stat of taskCategoryList" [value]="stat.taskTemplateCategoryID">
            {{ stat.taskTemplateCategoryName }}
        </mat-option>
    </mat-select>    
    </mat-form-field>

      <mat-form-field class="">
        <mat-label>Template Name</mat-label>
        <input matInput formControlName="taskTemplateName" maxlength="100" placeholder="add template name"/>
      </mat-form-field>

  </mat-dialog-content>
  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="basic" (click)="closeSaveAsTemplate()">Cancel</button>
    <button mat-flat-button class="calltoaction" type="submit" color="primary"
    [disabled]="addTemplateForm.invalid || !addTemplateForm.dirty" 
    (click)="AddTaskTemplate(addTemplateForm.value)">
     Add
     <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
     </mat-spinner></mat-icon>
   </button>
  </mat-dialog-actions>
</form>
</ng-template>



<ng-template #sendReminder>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>view_column</mat-icon>
    </span>
    Send Email Notification
    <button mat-icon-button (click)="closeSendReminder()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">

    <div class="allheaders">
      <div class="search">
        <mat-form-field class="example-full-width" appearance="fill">
          <mat-label>Email</mat-label>
          <input matInput maxlength="200" placeholder="Add email" [(ngModel)]="repeatTaskEmail">
        </mat-form-field>
      </div>
    </div>

  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="closeSendReminder()">Cancel</button>
    <button mat-flat-button color="primary" 
    (click)="onSendManualTaskReminder()">
    Send
  </button>
  </mat-dialog-actions>
</ng-template>



<ng-template #saveAsTemplateTaskDialog>
  <form [formGroup]="addTemplateForm">
    <h2 mat-dialog-title>
      <!-- {{taskTitleForSingleTask}} -->
      <span class="groupIcon"><mat-icon>create_new_folder</mat-icon></span>
      Save/Update Template
      <button mat-icon-button (click)="closeSaveAsTemplateForSingleTask()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>

    <mat-dialog-content>
      <mat-radio-group color="primary" aria-label="Select an option">
        <mat-radio-button value="0" (change)="OnCategoryChangeForSingleTask(0)" [checked]="categoryTypeForSingleTask==0"
          style="margin-right: 15px;">My Templates</mat-radio-button>
          <mat-radio-button value="2" *ngIf="isOfficeAdmin || isOrganizationAdmin" (change)="OnCategoryChangeForSingleTask(2)" [checked]="categoryTypeForSingleTask==2"
          style="margin-right: 15px;">Save as Organization Template</mat-radio-button>
        <!-- <mat-radio-button value="2" *ngIf="isOrganizationAdmin" (change)="OnCategoryChangeForSingleTask(2)" [checked]="categoryTypeForSingleTask==2"
          style="margin-right: 15px;">Save as Organization Template</mat-radio-button> -->
        <mat-radio-button value="1" *ngIf="isSuperAdmin" (change)="OnCategoryChangeForSingleTask(1)" [checked]="categoryTypeForSingleTask==1">
          Save Global Template Only</mat-radio-button>
      </mat-radio-group>

      <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" (selectedTabChange)="getTabDetailsForSingleTask($event)">
        <mat-tab label="New">

          <div class="tabContainer">
            <div class="d-flex">

              <mat-form-field appearance="fill">
                <mat-label>Select Category</mat-label>
                <mat-select formControlName="folderID">
                  <mat-option *ngFor="let stat of filteredTaskCategoryList" [value]="stat.taskTemplateCategoryID">
                    {{ stat.taskTemplateCategoryName }}
                  </mat-option>
                </mat-select>

              </mat-form-field>

              <button class="addBtn" mat-icon-button color="primary" (click)="openDialogAddWithRef()">
                <mat-icon>add</mat-icon> </button>
            </div>
            <mat-form-field class="">
              <mat-label>Template Name</mat-label>
              <input matInput formControlName="taskTemplateName" maxlength="100" placeholder="add template name" />
            </mat-form-field>
          </div>
        </mat-tab>

        <mat-tab label="Update Existing">
          <div class="tabContainer">

            <div class="searchSelectCat">
              <div class="selectCat">
                <mat-form-field appearance="fill">
                  <mat-label>Select Category</mat-label>
                  <mat-select (selectionChange)="getSelectTaskCategoryForSingleTask($event)">
                    <mat-option value="0">All</mat-option>
                    <mat-option *ngFor="let stat of filteredTaskCategoryList" [value]="stat.taskTemplateCategoryID">
                      {{ stat.taskTemplateCategoryName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>


              <div class="search">
                <mat-form-field class="example-full-width" appearance="fill">
                  <mat-label>Search</mat-label>
                  <input matInput maxlength="20" placeholder="Search Template"
                    (input)="searchTemplateForSingleTask($event.target.value)">
                </mat-form-field>
              </div>
            </div>


            <div class="tempalteList">
              <table cellspacing="0" cellspadding="0" *ngIf="!ShowNoRecordFoundTaskTemplates">
                <tr>
                  <th class="formName">Template Name</th>
                  <!-- <th>Category Name</th> -->
                  <th class="actBtn">Action</th>
                </tr>
                <tr *ngFor="let template of TaskTemplatesListForSingleTask"
                  [ngClass]="{ 'active': template.taskId === taskTemplateIDForSingleTask}">

                  <td class="formName">
                    {{template.templateName}}
                  </td>

                  <td class="actBtn">
                    <button mat-icon-button color="primary" mat-icon-button matTooltipClass="tooltip"
                      matTooltip="Select" (click)="SelectTemplateForAddTaskListForSingleTask(template)"><mat-icon>post_add</mat-icon>
                    </button>
                  </td>
                </tr>
              </table>
              <div *ngIf="ShowNoRecordFoundTaskTemplates" class="noRecordFound">No Records Found</div>
            </div>
          </div>

        </mat-tab>
      </mat-tab-group>

    </mat-dialog-content>

    <mat-dialog-actions *ngIf="showNew" align="start" fxLayout="row" fxLayoutAlign="space-between center">
      <button mat-button color="basic" (click)="closeSaveAsTemplate()">Cancel</button>
      <button mat-flat-button class="calltoaction" type="submit" color="primary"
        [disabled]="addTemplateForm.invalid || !addTemplateForm.dirty" (click)="AddTaskTemplateForSingleTask(addTemplateForm.value)">
        Add
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
          </mat-spinner></mat-icon>
      </button>
    </mat-dialog-actions>

    <mat-dialog-actions *ngIf="showExisting" align="start" fxLayout="row" fxLayoutAlign="space-between center">
      <button mat-button color="basic" (click)="closeSaveAsTemplateForSingleTask()">Cancel</button>
      <button mat-flat-button class="calltoaction" type="submit" color="primary"
        [disabled]="!updateTaskTemplateTasksButton" (click)="AddSingleTaskTemplateForSingleTask(addTemplateForm.value)">
        Update
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
          </mat-spinner></mat-icon>
      </button>
    </mat-dialog-actions>

  </form>
</ng-template>



<ng-template #importTasktemplate>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>backup_table</mat-icon></span>
    Template Gallery

    <!-- <button mat-stroked-button color="primary" class="import" *ngIf="selectedTemplate.length>0" (click)="importTaskTemplates()">Import</button> -->

    <button mat-icon-button (click)="closeImportTaskTemplate()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
 

    <div class="template-holder">
      <div class="left">

        <mat-form-field appearance="fill">
          <mat-label>Select Category</mat-label>
          <mat-select (selectionChange)="onTaskListTabChangeForTaskImport($event)" value="My Template">
            <mat-option value="My Template">My Template</mat-option>
            <mat-option value="Organization">Organization</mat-option>
            <!-- <mat-option value="Global">Global</mat-option> -->
          </mat-select>
        </mat-form-field>

        <div class="list" #categoryList>
          <ul>
            <li (click)="getTaskListThroughCategoryForTaskImport(0, 0)" [ngClass]="{'active': currentIndex == 0 }" >All</li>
            <ng-container  *ngFor="let stat of filteredTaskCategoryList; let i = index">
              <li (click)="getTaskListThroughCategoryForTaskImport(stat.taskTemplateCategoryID, i+1)" [ngClass]="{'active': currentIndex == i+1 }"  > {{ stat.taskTemplateCategoryName }}</li>
            </ng-container>           
          </ul>
        
        </div>

      </div>
     <div class="right"> 
       
      

       <div class="searrch">
        <mat-form-field class="example-full-width" appearance="fill">
          <mat-label>Search</mat-label>
          <input matInput maxlength="20" placeholder="Search Template"
            (input)="searchTemplateForSingleTask($event.target.value)">
        </mat-form-field>
       </div>
  
      

        <div class="tempalteList">
          <table cellspacing="0" cellspadding="0" *ngIf="!ShowNoRecordFoundTaskTemplates">
            <tr>
              <th> </th>
              <th>Template Name</th>             
              <th class="">&nbsp;</th>
            </tr>
            <tr *ngFor="let template of  TaskTemplatesListForSingleTask"
             [ngClass]="{ 'active': template.taskId === taskTemplateIDForSingleTask}">

             <td>
              <mat-checkbox color="primary" (change)="getCheckboxValues($event, template)">
              </mat-checkbox>
            </td> 

              <td class="formName">
                {{template.templateName}}
              </td>            

              <td>
                &nbsp;
              </td>
            </tr>
          </table>
          <div *ngIf="ShowNoRecordFoundTaskTemplates" class="noRecordFound">No Record Found</div>
        </div>

     
  
     </div>
  </div>  

  <section class="importTo" *ngIf="selectedTemplate.length>0">
    <p>Would you like to import data for the newly created task-list? If so, please select the appropriate options below. If not, simply uncheck any boxes you do not wish to pull data from.</p>
    <mat-checkbox color="primary" [(ngModel)]="AttachChecked" (change)="showOptions($event,'Attach')">Attach</mat-checkbox> &nbsp;
    <mat-checkbox color="primary" [(ngModel)]="AssigneeChecked" (change)="showOptions($event,'Assignee')">Assignee</mat-checkbox>&nbsp;
    <!-- <mat-checkbox color="primary" [(ngModel)]="NotifyChecked" (change)="showOptions($event,'Notify')">Notify</mat-checkbox> -->
  </section>

  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="basic" (click)="closeImportTaskTemplate()">Cancel</button>
    <button mat-flat-button class="calltoaction" type="submit" color="primary" *ngIf="selectedTemplate.length>0"
      (click)="importTaskTemplates()">
      Import     
    </button>
  </mat-dialog-actions> 

</ng-template>


<ng-template #customize>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>view_column</mat-icon>
    </span>
    Select the columns you want to display in this list
    <button mat-icon-button (click)="closeCustomeColumn()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>


  <mat-dialog-content class="mat-typography">

    <div class="allheaders">
      <div class="fixrow sep">
        <span>Column Headers</span>
        <span> Active Columns</span>
      </div>

      <ng-container *ngFor="let item of FieldColumnToogle;let i = index">        
        <div class="sep">
          <span>{{item.fieldName}}</span>
          <span>
            <mat-slide-toggle [checked]="item.isDisplay" color="primary" (change)="changedToggle(item,$event)">
            </mat-slide-toggle>
          </span>
        </div>
      </ng-container>
    </div>

  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="closeCustomeColumn()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]="!SubmitColumnsButton" (click)="onSubmitColumns()">Save</button>
  </mat-dialog-actions>
</ng-template>


<app-loader></app-loader>

